<template>
  <div class="guestbook-form-wrapper">
    <section class="guestbook-form">
      <header class="form-header">
        <div
          class="form-header__primary"
          :style="{ 'border-bottom': '3px solid ' + guestBookForm.formColor }"
        >
          {{ isSecLangActive ? guestBookForm.titleSec : guestBookForm.title }}
        </div>
        <div class="form-header__secondary">
          {{
            isSecLangActive ? guestBookForm.subtitleSec : guestBookForm.subtitle
          }}
        </div>
      </header>
      <div v-show="step == 1 || step == 2">
        <!-- Form receipt -->
        <section class="form-receipt">
          <div
            class="receipt-item"
            v-for="(service, index) in activeServices"
            :key="index"
            v-bind:class="{
              last:
                index == activeServices.size - 1 &&
                guestBookForm.serviceCharge == 0,
            }"
          >
            <div class="receipt-item__name">
              {{ isSecLangActive ? service.titleSec : service.title }}
            </div>
            <div class="receipt-item__price">
              {{
                convertNumber(service.price) + ' ' + guestBookForm.currency
              }}
            </div>
            <div class="receipt-item__amount">x {{ service.amount }}</div>
          </div>
          <div class="receipt-item last" v-if="guestBookForm.serviceCharge > 0">
            <div class="receipt-item__name">Service charge</div>
            <div class="receipt-item__price">
              {{ guestBookForm.serviceCharge + ' ' + guestBookForm.currency}}
            </div>
            <div class="receipt-item__amount">x 1</div>
          </div>
          <div class="receipt-item__total-price">
            <span>{{ activeLanguage == "DK" ? "TOTAL" : "TOTAL:" }}</span
            >
            <span
              >{{
                convertNumber(
                  Number(currentPrice) + guestBookForm.serviceCharge
                ) + ' ' + guestBookForm.currency
              }}
              </span
            >
          </div>
        </section>
      </div>
      <div v-if="step == 0">
        <div
          v-for="(category, categoryIndex) in guestBookForm.categories"
          :key="categoryIndex"
        >
          <section class="form-table">
            <!-- Table header -->
            <div
              class="form-header"
              :style="{ 'background-color': guestBookForm.formColor }"
            >
              <div :style="{ color: guestBookForm.textColor }">
                {{ isSecLangActive ? category.titleSec : category.title }}
              </div>
            </div>
            <ul class="form-list">
              <!-- Table cell -->
              <li
                class="table-cell__wrapper"
                v-for="item in category.items"
                :key="item.id"
              >
                <div class="table-cell">
                  <div class="table-cell__column column__title-and-price">
                    <div class="title">
                      {{ isSecLangActive ? item.titleSec : item.title }}
                    </div>
                    <div class="description" v-if="hasDescription(item)">
                      {{ isSecLangActive ? item.descriptions[1] : item.descriptions[0] }}
                    </div>
                  </div>
                  <div class="table-cell__column column__amount">
                    <div class="price">
                      {{ convertNumber(item.price) + ' ' + guestBookForm.currency }}
                    </div>
                    <div class="form-item-amount">x {{ item.amount }}</div>
                  </div>

                  <!-- Amount buttons -->
                  <div class="table-cell__column column__buttons">
                    <div
                      class="button-decrement"
                      :style="{ opacity: item.amount == 0 ? 0.5 : 1 }"
                      v-on:click="handleDecrement(item)"
                    >
                      <div class="button-decrement__text">
                        <v-icon name="minus" scale="0.75" />
                      </div>
                    </div>
                    <div
                      class="button-increment"
                      :style="{ background: guestBookForm.formColor }"
                      v-on:click="handleIncrement(item)"
                    >
                      <div
                        class="button-increment__text"
                        :style="{ color: guestBookForm.textColor }"
                      >
                        <v-icon name="plus" scale="0.75" />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </section>
        </div>
        <div
          class="form-total-price form-total-price--medium"
          :style="{ 'border-top': '3px solid ' + guestBookForm.formColor }"
        >
          {{ isSecLangActive ? "TOTAL:" : "TOTAL:" }}
          <span>{{ currentPrice + ' ' + guestBookForm.currency }}</span>
        </div>
        <div class="action-buttons">
          <FormButton
            :guestBookForm="guestBookForm"
            :buttonText="activeLanguage == 'DK' ? 'tilbage' : 'cancel'"
            buttonType="negative"
            @emitEvent="cancel"
          />
          <FormButton
            :guestBookForm="guestBookForm"
            :buttonText="activeLanguage == 'DK' ? 'bestil' : 'request'"
            buttonType="positive"
            :disabled="activeServices.size == 0"
            @emitEvent="confirm"
          />
        </div>
      </div>
      <div v-else-if="step == 1" class="form-confirm">

        <div v-if="guestBookForm.isCustomInputsEnabled">

          <div 
            v-for="(input, index) in guestBookForm.inputs"
            :key="index"
          >
            <div v-if="input.type == 'EMAIL'">
              <div
                class="form-text__medium"
                :style="{
                  color:
                    isEmailValid(customFormInputs[index].value) ||
                    customFormInputs[index].value == ' '
                      ? guestBookForm.formColor
                      : '#D95D5D',
                }"
              >
                {{ isSecLangActive ? input.labels[1] : input.labels[0] }}
              </div>
              <input
                class="form-email"
                :style="{
                  border:
                    isEmailValid(customFormInputs[index].value) ||
                    customFormInputs[index].value == ' '
                      ? '2px solid' + guestBookForm.formColor
                      : '2px solid #D95D5D',
                }"
                type="email"
                v-model="customFormInputs[index].value"
                :required="input.isRequired"
              />
            </div>
            <div v-else-if="input.type == 'PHONE'">
              <div
                class="form-text__medium"
                :style="{
                  color:
                    isPhoneValid(customFormInputs[index].value) ||
                    customFormInputs[index].value == ' '
                      ? guestBookForm.formColor
                      : '#D95D5D',
                }"
              >
                {{ isSecLangActive ? input.labels[1] : input.labels[0] }}
              </div>
              <input
                class="form-email"
                :style="{
                  border:
                    isPhoneValid(customFormInputs[index].value) ||
                    customFormInputs[index].value == ' '
                      ? '2px solid' + guestBookForm.formColor
                      : '2px solid #D95D5D',
                }"
                type="email"
                v-model="customFormInputs[index].value"
                :required="input.isRequired"
              />
            </div>
            <div v-else>
              <div
                class="form-text__medium"
                :style="{ color: guestBookForm.formColor }"
              >
                {{ isSecLangActive ? input.labels[1] : input.labels[0] }}
              </div>
              <input
                class="form-email"
                :style="{ border: '2px solid' + guestBookForm.formColor }"
                v-model="customFormInputs[index].value"
                :required="input.isRequired"
              />
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="!activeGuestInformation.guestRef">
            <div
              class="form-text__medium"
              :style="{ color: guestBookForm.formColor }"
            >
              {{ activeLanguage == "DK" ? "Navn" : "Name" }}
            </div>
            <input
              class="form-email"
              :style="{ border: '2px solid' + guestBookForm.formColor }"
              v-model="targetGuestName"
            />
            <div
              class="form-text__medium"
              :style="{ color: guestBookForm.formColor }"
            >
              {{ activeLanguage == "DK" ? "Værelsesnummer" : "Room number" }}
            </div>
            <input
              class="form-email"
              :style="{ border: '2px solid' + guestBookForm.formColor }"
              v-model="targetGuestRoomNumber"
              :placeholder="
                activeLanguage == 'DK'
                  ? 'Hvor kan vi finde dig?'
                  : 'Where can we find you?'
              "
            />
            <div
              class="form-text__medium"
              :style="{ color: guestBookForm.formColor }"
            >
              {{ activeLanguage == "DK" ? "Telefonnummer" : "Phone number" }}
            </div>
            <input
              class="form-email"
              :style="{ border: '2px solid' + guestBookForm.formColor }"
              v-model="targetGuestPhone"
            />
          </div>

          <div
            class="form-text__medium"
            :style="{ color: guestBookForm.formColor }"
          >
            {{ activeLanguage == "DK" ? "Kommentarer?" : "Any comments?" }}
          </div>
          <input
            class="form-email"
            :style="{ border: '2px solid' + guestBookForm.formColor }"
            v-model="targetGuestComment"
          />

          <div
            class="form-text__medium"
            :style="{
              color:
                isEmailValid(targetGuestEmail) ||
                targetGuestEmail == ' '
                  ? guestBookForm.formColor
                  : '#D95D5D',
            }"
          >
            {{
              activeLanguage == "DK"
                ? "Bekræftelsesemail"
                : "Request confirmation email"
            }}
          </div>
          <input
            class="form-email"
            :style="{
              border:
                isEmailValid(targetGuestEmail) ||
                targetGuestEmail == ' '
                  ? '2px solid' + guestBookForm.formColor
                  : '2px solid #D95D5D',
            }"
            type="email"
            v-model="targetGuestEmail"
            required
          />
        </div>

        <div class="action-buttons">
          <FormButton
            :guestBookForm="guestBookForm"
            :buttonText="activeLanguage == 'DK' ? 'tilbage' : 'back'"
            buttonType="negative"
            @emitEvent="cancel"
          />
          <template v-if="guestBookForm.isCustomInputsEnabled">
            <FormButton
              :guestBookForm="guestBookForm"
              :buttonText="
                activeLanguage == 'DK' ? 'bekræft bestiling' : 'confirm request'
              "
              buttonType="positive"
              :disabled="areInputsInvalid"
              @emitEvent="confirm"
            />
          </template>
          <template v-else>
            <FormButton
              :guestBookForm="guestBookForm"
              :buttonText="
                activeLanguage == 'DK' ? 'bekræft bestiling' : 'confirm request'
              "
              buttonType="positive"
              :disabled="!isEmailValid(targetGuestEmail)"
              @emitEvent="confirm"
            />
          </template>
        </div>
      </div>
      <div v-else-if="step == 2" class="form-confirmed">
        <h2>
          <template v-if="guestBookForm.isCustomNoteEnabled">
              {{ isSecLangActive ? guestBookForm.customNoteHeaderSec : guestBookForm.customNoteHeader }}
          </template>
          <template v-else>
            {{ activeLanguage == "DK" ? "Tak!" : "Thank you!" }}
          </template>
          <svg
            style="margin-left: 4px"
            width="32"
            height="32"
            viewBox="0 0 60 60"
            :fill="guestBookForm.formColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d)">
              <path
                d="M30 53C16.1925 53 5 41.8075 5 28C5 14.1925 16.1925 3 30 3C43.8075 3 55 14.1925 55 28C55 41.8075 43.8075 53 30 53ZM20 23L15 28L27.5 40.5L45 23L40 18L27.5 30.5L20 23Z"
              />
            </g>
            <defs>
              <filter
                id="filter0_d"
                x="0"
                y="0"
                width="60"
                height="60"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2.5" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </h2>
        <p>
          <template v-if="guestBookForm.isCustomNoteEnabled">
              {{ isSecLangActive ? guestBookForm.customNoteDescriptionSec : guestBookForm.customNoteDescription }}
          </template>
          <template v-else>
            {{
              activeLanguage == "DK"
                ? "Vi har sendt en bekræftelse til din email"
                : "We have sent a confirmation to your email"
            }}
          </template>
        </p>
        <FormButton
          :guestBookForm="guestBookForm"
          :buttonText="'OK'"
          buttonType="neutral"
          @emitEvent="confirm"
        />
      </div>
    </section>
  </div>
</template>

<script>
import store from "../../store/index.js";
import * as actions from "../../store/actionTypes/types";
import { mapState, mapGetters } from "vuex";
import cookieMixin from "@/mixins/cookieMixin";
import { sendForm } from '@/callables'
import FormButton from "@/components/GuestbookForm/FormButton";

export default {
  components: {
    FormButton,
  },
  props: {
    box: Object,
    activeGuestInformation: Object,
    secondLang: Boolean,
    activeLanguage: String,
    cookieExists: [String],
  },
  mixins: [cookieMixin],
  data: function () {
    return {
      guestBookForm: JSON.parse(JSON.stringify(this.box)),
      step: 0,
      customFormInputs: [],
      isOrderFinished: false,
      targetGuestEmail: " ",
      targetGuestComment: "",
      targetGuestName: !this.activeGuestInformation.guestRef
        ? ""
        : this.activeGuestInformation.name,
      targetGuestRoomNumber: !this.activeGuestInformation.guestRef
        ? ""
        : this.activeGuestInformation.roomnumber,
      targetGuestPhone: !this.activeGuestInformation.guestRef
        ? ""
        : this.activeGuestInformation.phone,
    };
  },
  created: function () {
    store.dispatch({
      type: actions.initializeBasket,
      form: this.guestBookForm,
    });
    if(this.guestBookForm.isCustomInputsEnabled) {
      this.customFormInputs = this.guestBookForm.inputs.map( input => {
        return {
          value: " ",
          required: input.isRequired,
          type: input.type,
          label: input.labels[0],
        }
      });
    }
  },
  watch: {
    $route: function () {
      if (window.location.hash == "#productsOrder") {
        this.step = 0;
      } else if (window.location.hash == "#productsConfirm") {
        this.step = 1;
        if (this.isOrderFinished) {
          this.closeModal();
        }
      }
    },
  },
  computed: {
    isSecLangActive() {
      return this.secondLang && this.cookieExists;
    },
    ...mapGetters(["currentPrice"]),
    ...mapState({
      activeServices: (state) => state.activeServices,
      basket: (state) => state.basket,
    }),
    areInputsInvalid() {
      let isInvalid = false;
      this.customFormInputs.forEach(inputObject => {
        if(
          (inputObject.required && inputObject.value.trim() == "") 
          || (inputObject.required && inputObject.type == 'EMAIL'
            && !this.isEmailValid(inputObject.value))
          || (inputObject.required && inputObject.type == 'PHONE'
            && !this.isPhoneValid(inputObject.value))
        ) {
          isInvalid = true;
        } 
      });
      return isInvalid;
    }
  },
  methods: {
    sendForm: function () {
      let itemArray = Array.from(this.$store.state.activeServices);
      itemArray.push({
        id: -1,
        amount: 1,
        title: "Service charge",
        price: this.guestBookForm.serviceCharge,
      });

      sendForm({
        isCustomForm: this.guestBookForm.isCustomInputsEnabled, 
        hotelID: this.$hotelId,
        guestRef: this.activeGuestInformation.guestRef,
        currency: this.guestBookForm.currency,
        formData: this.guestBookForm.isCustomInputsEnabled ? {
          customForm: this.customFormInputs
        } : {
          guestName: this.targetGuestName,
          roomNumber: this.targetGuestRoomNumber,
          guestPhone: this.targetGuestPhone,
          guestEmail: this.targetGuestEmail,
          guestComment: this.targetGuestComment,
        },
        formID: this.guestBookForm.id,
        formTitle: this.guestBookForm.title,
        targetEmail: this.guestBookForm.email,
        items: itemArray,
      })
      .catch(function (error) {
        if (process.env.VUE_APP_DEPLOYMENT_TYPE != "production") {
          console.log(error);
        }
      });
    },
    handleIncrement: function (item) {
      store.dispatch({
        type: actions.modifyBasket,
        key: item.id,
        value: { ...item, amount: ++item.amount },
      });

      store.dispatch({
        type: actions.addService,
        service: item,
      });
    },
    handleDecrement: function (item) {
      if (item.amount > 0) {
        store.dispatch({
          type: actions.modifyBasket,
          key: item.id,
          value: { ...item, amount: --item.amount },
        });

        if (item.amount == 0) {
          store.dispatch({
            type: actions.removeService,
            service: item,
          });
        }
      }
    },
    convertNumber(someValue) {
      return someValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    isEmailValid(emailAddress) {
      return /\S+@\S+\.\S+/.test(String(emailAddress).toLowerCase());
    },
    isPhoneValid(phoneNumber) {
      return /^\+?\d*$/.test(phoneNumber);
    },
    hasDescription(item) {
      return item.descriptions && item.descriptions[0].trim().length > 0;
    },
    closeModal: function () {
      this.step = 0;
      this.$store.state.currentPrice = 0;
      this.$store.state.activeServices = new Set();
      window.location.hash = "";
      store.dispatch({
        type: actions.clearServices,
      });
      this.$emit("closeModal");
    },
    confirm: function () {
      if (this.step == 0) {
        this.step++;
        window.location.hash = "productsConfirm";
      } else if (this.step == 1) {
        this.sendForm();
        this.step++;
        this.isOrderFinished = true;
        window.location.hash = "productsThanks";
      } else if (this.step == 2) {
        this.closeModal();
      } else {
        this.step++;
      }
    },
    cancel: function () {
      if (this.step == 1) {
        this.step--;
        window.location.hash = "productsOrder";
      } else if (this.step == 2) {
        this.step--;
        window.location.hash = "productsConfirm";
      } else {
        this.closeModal();
      }
    },
  },
};
</script>

<style scoped>
* {
  margin: 0px;
  padding: 0px;
  outline: none;
}

/*
    Table
  */

.form-table {
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 8px;
  margin: 13px 0px 15px 0px;
}

.form-header {
  padding: 10px 0;
  color: white;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-weight: 500;
  font-size: 0.9em;
  line-height: 24px;
}

.form-list {
  text-decoration: none;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(112, 112, 112, 0.5);
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.form-list__completed {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

/*
    Table cell
  */

.table-cell__wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid rgba(112, 112, 112, 0.5);
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
}

.table-cell {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
}

.column__title-and-price {
  font-size: 14px;
  margin: 4px 5px;
  text-align: left;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.title,
.price,
.form-item-amount {
  line-height: 20px;
}

.title {
  display: flex;
  align-items: flex-end;
}

.description {
  font-size: 12px;
}

.price {
  font-size: 12px;
  color: #707070;
}

.column__amount {
  display: flex;
  align-items: center;
  font-size: 16px;
  width: 70px;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: space-between;
}

.column__buttons {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 88px;
}

/*
    Amount buttons
  */

.button-increment,
.button-decrement {
  color: #ffffff;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  margin: 8px;
  user-select: none;
}

.button-decrement {
  background: #c9c9c9;
  margin-right: 0;
}

.button-decrement__text,
.button-increment__text {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

/* Remove extra shadow from list cell per category */
.form-item:last-child {
  border-bottom: 0px;
}

.form-email {
  display: flex;
  width: 100%;
  height: 50px;
  padding-left: 14px;
  font-size: 18px;
  border: 2px solid #d95d5d;
  box-sizing: border-box;
  border-radius: 8px;
  background-image: none;
  background-color: transparent;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.form-text__medium {
  color: #d95d5d;
}

.form-email-invalid {
  border: 2px solid #d95d5d;
}

.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: all 0.5s;
  opacity: 1;
}

.fadeIn-enter,
.fadeIn-leave-to {
  transition: all 0.5s;
  opacity: 0;
}

.guestbook-form-wrapper {
  background-color: white;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.guestbook-form {
  margin: 30px auto 0px;

  /* iphone 5 */
  width: 320px;
  max-height: 568px;
}

.form-header {
  color: #707070;
  padding-bottom: 8px;
  text-align: center;
}

.form-confirm,
.form-receipt,
.form-confirmed {
  max-width: 285px;
  margin-right: auto;
  margin-left: auto;
}

.form-confirmed {
  margin-top: 16px;
}

.form-confirmed h2 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
}

.form-confirmed p {
  text-align: center;
  margin-top: 10px;
}

.form-confirmed >>> .action-button {
  width: 100%;
  margin-top: 16px;
}

.form-button {
  display: flex;
  justify-content: flex-end;
  margin-top: 26px;
}

.form-text__medium {
  margin-top: 23px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}

.form-text__large {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 18px;
  color: #707070;
  font-weight: 500;
  font-size: 1.5em;
  line-height: 36px;
}

.form-header__primary {
  font-weight: 600;
  font-size: 1.2em;
  line-height: 33px;
  margin-bottom: 8px;
}

.form-header__secondary {
  font-weight: 500;
  font-size: 0.75em;
  line-height: 18px;
}

.form-total-price {
  text-align: center;
  color: #707070;
  margin: 15px 0 0 0;
  padding: 7px 0 0 0;

  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
}

.form-checkmark {
  display: flex;
  align-items: center;
  margin-left: 13px;
}

.action-buttons {
  margin: 21px 0 0 0;
  padding-bottom: 50px;

  display: flex;
  justify-content: space-around;
}

* {
  margin: 0px;
  padding: 0px;
}

.form-receipt {
  margin: 0px auto;
  margin-top: 22px;
  padding-top: 21px;
  background: #ededed;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}

.receipt-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  margin-right: 15px;
  margin-left: 11px;
  padding: 8px 0;
  border-bottom: 0.7px solid rgba(112, 112, 112, 0.5);
}

.last {
  padding-bottom: 26px;
  border-bottom: 1.5px dashed #908f8f;
}

.receipt-item__name {
  text-align: left;
  width: 65%;
}

.receipt-item__price {
  text-align: right;
  width: 20%;
}

.receipt-item__amount {
  text-align: right;
  width: 15%;
}

.receipt-item__total-price {
  display: flex;
  margin: 0 15px;
  font-weight: 500;
  color: #707070;
  font-size: 1.5625em;
  line-height: 37px;
  justify-content: space-between;
  padding: 12px 0px;
}

@media (max-width: 375px) {
  .guestbook-form {
    flex-direction: column;
    max-width: 90%;
  }

  .action-buttons {
    margin: 14px 0 0 0;
    padding-bottom: 45px;
  }
}

@media (max-width: 350px) {
  .guestbook-form {
    flex-direction: column;
    max-width: 90%;
  }

  .action-buttons {
    margin: 12px 0 0 0;
    padding-bottom: 40px;
  }
}

@media (max-width: 335px) {
  .guestbook-form {
    flex-direction: column;
    max-width: 90%;
  }

  .action-buttons {
    margin: 10px 0 0 0;
    padding-bottom: 35px;
  }
}
</style>
